import { NgModule } from "@angular/core";
import { TimelineComponent } from "./timeline.component";
import { TimeLineRoutingModule } from "./timeline.routing.module";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [TimelineComponent],
  imports: [CommonModule,TimeLineRoutingModule],
  exports: [TimelineComponent]
})
export class TimeLineModule {}
